(function () {
    const liquid = PLUG.liquid;
    const section = document.getElementsByClassName("main-homepage-section")[0];
    const sectionId = section.id;
    const rootUrl = liquid.rootUrl + (!liquid.rootUrl.endsWith("/") ? "/" : "");  // e.g. "/", "/es/", etc.
    const sectionInner = document.querySelector(".main-homepage-inner");
    const collectionHandle = sectionInner.dataset.collectionHandle;
    const sortSelects = [
        document.getElementById("SortBy"),
        document.getElementById("SortBy-mobile")
    ];
    console.log(`sortSelects length: ${sortSelects.length}`);
    const sortDisabled = sortSelects.every(select => !select);
    const originalSearchParams = new URLSearchParams(location.search);
    const originalPage = originalSearchParams.get("page");
    const originalSort = originalSearchParams.get("sort_by");

    let pageNum = originalPage ? Number(originalPage) : 1;
    let activeSort;
    if (!sortDisabled) {
        activeSort = originalSort || sortSelects[0].value; // e.g. price-ascending
    }

    (function init() {
        if (originalSort || originalPage) {
            goToPage(pageNum);
        } else {
            setupPaginationListeners();
        }

        PLUG.preferenceCookies.setupDesignGrid(
            section.querySelector(".product-grid-container")
        );

        if (!sortDisabled) {
            updateSortSelects();
            setupSortListeners();
        }

        window.addEventListener("popstate", (event) => {
            const searchParams = new URLSearchParams(location.search);
            const urlPageNum = searchParams.get("page") ? Number(searchParams.get("page")) : 1;
            if (!sortDisabled) {
                activeSort = searchParams.get("sort_by") || sortSelects[0].value;
                updateSortSelects();
            }
            goToPage(urlPageNum, false);
        });
    })();

    const removeGridItemAnimations = function (gridContainer) {
        const items = Array.from(gridContainer.getElementsByClassName("grid__item"));
        items.forEach(item => {
            item.classList.remove("scroll-trigger", "animate--slide-in");
            delete item.dataset.cascade;
        });
    };

    function goToPage(newPageNum, updateHistory=true) {
        const samePageNum = (pageNum === newPageNum);
        pageNum = newPageNum;

        document.getElementById("product-grid").style.opacity = "0";

        if (updateHistory) {
            const searchParams = new URLSearchParams(location.search);
            searchParams.set("sort_by", activeSort);
            searchParams.set("page", pageNum);
            if (!samePageNum) {
                history.pushState({ page: pageNum }, "", `${rootUrl}?${searchParams.toString()}`);
            } else {
                history.replaceState({ page: pageNum }, "", `${rootUrl}?${searchParams.toString()}`);
            }
        }

        PLUG.utils.fetchSection(
            sectionId.replace("shopify-section-", ""),
            `${rootUrl}collections/${collectionHandle}`,
            (
                !sortDisabled
                ? `?sort_by=${activeSort}&page=${pageNum}`
                : `?page=${pageNum}`
            )
        ).then(newSection => {
            const newGridContainer = newSection.querySelector(".product-grid-container");
            removeGridItemAnimations(newGridContainer);
            PLUG.utils.replaceElement(
                section.querySelector(".product-grid-container"),
                newGridContainer
            );
            sectionInner.style.opacity = "";  // This is sometimes set to 0 by an inline script in main-homepage.liquid.
            setupPaginationListeners();
            PLUG.preferenceCookies.setupDesignGrid(newGridContainer);
        });
    }

    function sort(criteria) {
        activeSort = criteria;
        goToPage(1);
    }

    function updateSortSelects() {
        if (sortDisabled) return;
        sortSelects.forEach(sortSelect => {
            sortSelect.value = activeSort;
        });
    }

    function setupSortListeners() {
        if (sortDisabled) return;
        sortSelects.forEach(sortSelect => {
            sortSelect.addEventListener("change", () => {
                sortSelects[0].value = sortSelect.value;
                sortSelects[1].value = sortSelect.value;
                sort(sortSelect.value);
            });
        });
    }

    function setupPaginationListeners() {
        const paginationLinks = Array.from(section.getElementsByClassName("pagination__item"));
        paginationLinks.forEach(link => {
            link.addEventListener("click", (e) => {
                e.preventDefault();
                const newPageNum = (
                    link.classList.contains("pagination__item--prev") ? pageNum - 1
                    : link.classList.contains("pagination__item--next") ? pageNum + 1
                    : Number(link.textContent)
                );
                window.scrollTo({
                    top: section.getBoundingClientRect().top + window.scrollY - 72,
                    behavior: "smooth"
                });
                goToPage(newPageNum);
            });
        });
    }

})();
